export default {
  init() {
    // JavaScript to be fired on the home page

    var anable_kitchenadvisor = document.getElementById('anable-kitchenadvisor');
    if (anable_kitchenadvisor) {
      anable_kitchenadvisor.addEventListener('click', function () {
        // 1. set cookie
        document.cookie = 'anablemenu=true';
        // 2. reloadpage
        location.hash = '#to-iframe';
        location.reload();
      });
    }
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/themenwelten.js